import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-collapsible/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-context-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-form/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-hover-card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-label/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-menubar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-one-time-password-field/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-password-toggle-field/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-portal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-radio-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toggle-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toggle/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toolbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/app/node_modules/@radix-ui/themes/dist/esm/components/avatar.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/callout.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/checkbox-cards.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/checkbox-group.js");
;
import(/* webpackMode: "eager", webpackExports: ["Checkbox"] */ "/app/node_modules/@radix-ui/themes/dist/esm/components/checkbox.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/context-menu.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/dropdown-menu.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/radio-group.js");
;
import(/* webpackMode: "eager", webpackExports: ["Radio"] */ "/app/node_modules/@radix-ui/themes/dist/esm/components/radio.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/segmented-control.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/select.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/text-field.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemePanel"] */ "/app/node_modules/@radix-ui/themes/dist/esm/components/theme-panel.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/themes/dist/esm/components/theme.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/images/placeholders/placeholder-video.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/admin/sidebar/AdminSidebar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/admin/sidebar/items/login/LoginButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/cleverfeed/CleverFeedLocationSearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchoolFeedPageWrapperHeaderClientMobileDropdown"] */ "/app/packages/components/components/header/cleverfeed/client/SchoolFeedPageWrapperHeaderClientMobileDropdown.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/header/cleverfeed/styles/CleverFeedHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/header/cleverfeed/styles/SchoolFeedPageWrapperHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/header/cleverfeed/styles/SubmitOrganizationButton.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["WebAppInstallPrompt"] */ "/app/packages/components/components/header/WebAppInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminMenuClientWrapper"] */ "/app/packages/components/components/misc/AdminMenuClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationContainer"] */ "/app/packages/components/components/notifications/NotificationContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileEventsWidgetLink"] */ "/app/packages/components/components/schoolfeed/EventsWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/schoolfeed/leaderboard/Leaderboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchoolFeedNewsLoading","default"] */ "/app/packages/components/components/schoolfeed/SchoolFeedNewsDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/schoolfeed/SchoolFeedSplainerPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/styles/SchoolFeedDisplay.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/styles/UnclaimedPage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNewsWidgetLink"] */ "/app/packages/components/components/schoolfeed/widgets/NewsWidget.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/WidgetRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/utilities/ClickableLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DragAndDropProvider"] */ "/app/packages/components/components/utilities/DragAndDropProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/utilities/rollbar/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerManager"] */ "/app/packages/components/components/utilities/ServiceWorkerManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnreadNotificationsConsumer"] */ "/app/packages/components/components/utilities/UnreadNotificationsConsumer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/AccordionItemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/AlphaCollectionPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/CalendarPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/MapFixedCollectionPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/NewsItemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/SearchPage/SearchPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/styles/LeaderboardPage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/styles/ContentItemPage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/UserDashboard/UserDashboardPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/UserSettings/UserSettingsPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/stores/ClientTransitionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreContext"] */ "/app/packages/components/stores/StoreContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/styles/_variables.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleContextProvider"] */ "/app/packages/components/utils/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/schoolfeed/app/[lang]/[[...all]]/ProfileCompletionCheck.jsx");
